import React from 'react'
import PropTypes from 'prop-types'
import {Box, Text, Progress} from '@chakra-ui/react'
import {useIntl, FormattedNumber} from 'react-intl'

const ApproachingDiscounts = ({shipments, currency, isApplied, isMiniCart = false}) => {
    const intl = useIntl()
    const getApproachingPromotionMessage = (amountLeft) => {
        if (amountLeft !== 0) {
            const formattedAmountLeft = (
                <FormattedNumber value={amountLeft} style="currency" currency={currency} />
            )

            if (amountLeft > 10) {
                return intl.formatMessage(
                    {
                        id: 'free_shipping.amount_left',
                        defaultMessage: '{amountLeft} away from FREE shipping!'
                    },
                    {amountLeft: formattedAmountLeft}
                )
            } else {
                return intl.formatMessage(
                    {
                        id: 'free_shipping.so_close',
                        defaultMessage: 'SO close! {amountLeft} away from FREE shipping!'
                    },
                    {amountLeft: formattedAmountLeft}
                )
            }
        }

        if (isApplied) {
            return intl.formatMessage({
                id: 'free_shipping.qualified_free_shipping',
                defaultMessage: 'Yay! You’ve qualified for FREE shipping!'
            })
        }
    }

    return (
        <>
            {shipments?.map((shipment, shipmentIndex) =>
                shipment.shippingMethod?.shippingPromotions?.map((promotion, promotionIndex) => {
                    if (promotion?.c_approachingDiscounts?.qualifiesForFreeShipping) {
                        const distanceFromThreshold =
                            promotion?.c_approachingDiscounts?.distanceFromThreshold || 0
                        const message = getApproachingPromotionMessage(distanceFromThreshold)

                        // Only render if there's a valid message to display
                        if (!message) {
                            return null
                        }

                        return (
                            <Box
                                key={`${shipmentIndex}-${promotionIndex}`}
                                mb={isMiniCart ? '8.5px' : {base: '24.5px', lg: '32.5px'}}
                            >
                                <Text mb="4">{message}</Text>

                                <Progress
                                    value={promotion?.c_approachingDiscounts?.percentage ||
                                        (promotion?.c_approachingDiscounts?.qualifiesForFreeShipping && !promotion?.c_approachingDiscounts?.distanceFromThreshold && 100)
                                    }
                                    colorScheme="brand"
                                    size="sm"
                                />
                            </Box>
                        )
                    }
                    return null
                })
            )}
        </>
    )
}

ApproachingDiscounts.propTypes = {
    shipments: PropTypes.arrayOf(
        PropTypes.shape({
            shippingPromotions: PropTypes.arrayOf(
                PropTypes.shape({
                    c_approachingDiscounts: PropTypes.shape({
                        discountMsg: PropTypes.string,
                        percentage: PropTypes.number
                    })
                })
            )
        })
    ),

    currency: PropTypes.string,

    isApplied: PropTypes.bool,

    isMiniCart: PropTypes.bool
}

export default ApproachingDiscounts
